import { render, staticRenderFns } from "./WarningsSettings.vue?vue&type=template&id=2379c00e&scoped=true"
import script from "./WarningsSettings.vue?vue&type=script&lang=js"
export * from "./WarningsSettings.vue?vue&type=script&lang=js"
import style0 from "./WarningsSettings.vue?vue&type=style&index=0&id=2379c00e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2379c00e",
  null
  
)

export default component.exports